import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'

const ROWS = [
  { label: 'Asset Classes', std: 'Forex, Metals, Energies, Indices, Crypto', ecn: 'Forex, Metals, Energies, Indices, Crypto', pro: 'Forex, Metals, Energies, Indices, Crypto' },
  { label: 'Spreads From', std: '1.0 pips', ecn: '0.0 pips', pro: '0.0 pips' },
  { label: 'Commission', std: 'None', ecn: '$3.5 / lot per side', pro: 'None' },
  { label: 'Leverage up to', std: '1:1000', ecn: '1:1000', pro: '1:1000' },
  { label: 'Minimum Deposit', std: '$100', ecn: '$500', pro: '$5,000' },
  { label: 'Minimum Trade Size', std: '0.01 lots', ecn: '0.01 lots', pro: '0.01 lots' },
  { label: 'Maximum Total Trade Size', std: 'Unlimited', ecn: 'Unlimited', pro: 'Unlimited' },
  { label: 'Account Currency', std: 'USD, USDT', ecn: 'USD, USDT', pro: 'USD, USDT' },
  { label: 'Order Execution', std: 'Market', ecn: 'Market', pro: 'Market' },
  { label: 'Negative Balance Protection', std: '✓', ecn: '✓', pro: '✓' },
]

export default function AccountComparison() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xac-wrap { overflow-x: auto; border: 1px solid ${C.bdr}; border-radius: 12px; }
        .xac-table { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 640px; }
        .xac-table th, .xac-table td { padding: 12px 16px; border-bottom: 1px solid ${C.bdr}; text-align: center; }
        .xac-table th { color: ${C.tx}; font-family: ${fOutfit}; font-weight: 700; }
        .xac-table td:first-child, .xac-table th:first-child { text-align: left; color: ${C.tx3}; }
        .xac-table td { color: ${C.tx2}; }
      `}</style>
      <PublicNav active="Trading" />

      <section style={{ padding: '130px 24px 50px', textAlign: 'center', borderBottom: `1px solid ${C.bdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Account Types</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 12px', color: C.tx }}>Compare Trading Account Types</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, maxWidth: '520px', margin: '0 auto' }}>Choose the account structure that fits how you trade.</p>
      </section>

      <section style={{ padding: '60px 24px', maxWidth: '1000px', margin: '0 auto' }}>
        <div className="xac-wrap">
          <table className="xac-table">
            <thead>
              <tr><th></th><th>STD</th><th>ECN</th><th>PRO</th></tr>
            </thead>
            <tbody>
              {ROWS.map(r => (
                <tr key={r.label}><td>{r.label}</td><td>{r.std}</td><td>{r.ecn}</td><td>{r.pro}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '28px' }}>
          <Link to="/trading/std-account" style={{ fontSize: '13px', fontWeight: 700, border: `1px solid ${C.bdr}`, color: C.tx2, padding: '11px 24px', borderRadius: '999px', textDecoration: 'none' }}>STD Details</Link>
          <Link to="/trading/ecn-account" style={{ fontSize: '13px', fontWeight: 700, border: `1px solid ${C.bdr}`, color: C.tx2, padding: '11px 24px', borderRadius: '999px', textDecoration: 'none' }}>ECN Details</Link>
          <Link to="/trading/pro-account" style={{ fontSize: '13px', fontWeight: 700, border: `1px solid ${C.bdr}`, color: C.tx2, padding: '11px 24px', borderRadius: '999px', textDecoration: 'none' }}>PRO Details</Link>
          <Link to="/signup" style={{ fontSize: '13px', fontWeight: 700, background: C.primary, color: C.dark, padding: '11px 24px', borderRadius: '999px', textDecoration: 'none' }}>Sign Up</Link>
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}
